import Vue from 'vue'

class TariffRepository {

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/pricing/tariff/' + id,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  create(tariff) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/pricing/tariff',
        method: 'post',
        data: tariff,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  update(id, tariff) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/pricing/tariff/' + id,
        method: 'put',
        data: tariff,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  search(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/pricing/tariff/search',
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

    delete(tariffId) {
      return new Promise((resolve, reject) => {
        Vue.auth.fetch({
          url: `/api/pricing/tariff/${tariffId}`,
          method: 'delete',
        }).then(response => {
          resolve(response.data)
        }).catch(err => {
          reject(err)
        })
      })
    }
}

export default new TariffRepository()